import { StoryPeerType } from '@weblite/ts-action/story'
import { StoryAnalyticsEvents, StoryContent, StoryType } from './types'
import { getStoriesByPeerIdAndPeerType } from './react-hooks'

export enum OpenStorySource {
  STORY_RIBBON = 'STORY_RIBBON',
  ROOM_LIST = 'ROOM_LIST',
  ROOM_PROFILE = 'ROOM_PROFILE',
  ROOM = 'ROOM',
  ROOM_APP_BAR = 'ROOM_APP_BAR',
  UNKNOWN = 'UNKNOWN',
}

export const StoryAnalyticsApi = {
  swipe(direction: 'NEXT' | 'PREVIOUS', type: 'TAP' | 'SWIPE') {
    analite(StoryAnalyticsEvents.STORY_SWIPE, {
      direction,
      type,
    })
  },
  open(peerId: string, peerType: StoryPeerType, source: OpenStorySource) {
    analite(StoryAnalyticsEvents.STORY_OPEN, {
      targetType: peerType,
      targetId: peerId,
      source,
    })
  },
  create(peerId: string, peerType: StoryPeerType, type: StoryType) {
    const prevStories = getStoriesByPeerIdAndPeerType(peerId, peerType)
    analite(StoryAnalyticsEvents.STORY_CREATE, {
      type,
      source: peerType,
      nthStory: (prevStories?.length || 0) + 1,
    })
  },
  remove(peerId: string, peerType: StoryPeerType, storyId: string) {
    const stories = getStoriesByPeerIdAndPeerType(peerId, peerType)
    const story = stories?.find(story => story.id === storyId)
    analite(StoryAnalyticsEvents.STORY_REMOVE, {
      source: peerType,
      type: (story?.content as StoryContent)[0].type || 'unknown',
    })
  },
  profileClick(peerId: string, peerType: StoryPeerType) {
    analite(StoryAnalyticsEvents.STORY_PROFILE_CLICK, {
      targetType: peerType,
      targetId: peerId,
    })
  },
  toggleMute(mute: boolean) {
    analite(StoryAnalyticsEvents.STORY_MUTE_CLICK, {
      mute,
    })
  },
  viewersListClick(type: string, peerType: StoryPeerType) {
    analite(StoryAnalyticsEvents.STORY_VIEWER_LIST_CLICK, {
      type,
      source: peerType,
    })
  },
}
